
import Shimmer from "@/components/ui/shimmer";

export const PlanViewShimmer = () => {
  return (
    <div className="min-h-screen bg-background text-foreground transition-colors duration-300">
      <main className="container mx-auto px-4 sm:px-6 py-4 sm:py-6">
        <div className="flex items-center gap-2 mb-6">
          <Shimmer className="h-10 w-24" />
          <Shimmer className="h-6 w-48" />
        </div>
        <Shimmer className="h-4 w-full max-w-md mb-6" />
        <div className="space-y-6">
          <Shimmer className="h-32 w-full rounded-lg" />
          <Shimmer className="h-32 w-full rounded-lg" />
        </div>
      </main>
    </div>
  );
};
